export default __webpack_public_path__ + "static/media/todoapp.4600f035.PNG";